export { default } from './BorrowingStatusIcon';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingStatusIcon/index.js